import React from 'react';
import Translate from '../../../../../../../../components/Translate';
import Tooltip from '../../../../../../../../components-new/general/Tooltip';
import './WebhookTypeChip.css';

/*
 * Which event a webhook fires on.
 *
 * It was printed as the plain translation of the enum, and two of the three run
 * to a sentence - "User ended conversation with operator (get
 * operatorConversation/session id)" - in a column an eighth of the table wide.
 * The parenthesis is a note for whoever is wiring the endpoint up, not a name.
 *
 * So: a short name in a chip, with the full sentence on the tooltip. Each type
 * keeps its own colour, which is what lets a list of fifty calls be read by
 * shape rather than by reading every line.
 */
const TYPES = {
    CONNECT_TO_OPERATOR: {tone: 'brand', short: 'webhookTypeConnect'},
    USER_ENDED_CONVERSATION_WITH_OPERATOR: {tone: 'neutral', short: 'webhookTypeEnded'},
    SESSION_EVALUATION: {tone: 'warning', short: 'webhookTypeRating'},
};

const WebhookTypeChip = ({type}) => {
    const known = TYPES[type];

    return (
        <Tooltip text={type} style={{display: 'inline-flex', maxWidth: '100%'}}>
            <span className={'webhook-type webhook-type--' + (known ? known.tone : 'neutral')}>
                {/* an enum this component has not been told about is still worth
                    showing - it is a webhook that exists and is firing */}
                <Translate text={known ? known.short : type}/>
            </span>
        </Tooltip>
    );
};

export default WebhookTypeChip;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/resources/webhooks/WebhookTypeChip.jsx